export default {
  namespaced: true,

  state: {
    windowsWidth: window.innerWidth,
  },

  mutations: {
    updateWindowsWidth(state, width) {
      state.windowsWidth = width;
    },
  },

  getters: {
    isMobile(state) {
      return state.windowsWidth < 600;
    },
    isTabletPortraitUp(state) {
      return state.windowsWidth >= 600;
    },
    isTabletLandscapeUp(state) {
      return state.windowsWidth >= 900;
    },
  },
};
